//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoContainer from '@/components/VideoContainer'
import FileContainer from '@/components/FileContainer';
export default {
  name: "OccupationalSafetyPostDialog",
  data() {
    return {
      info: {},
      showDialog: false
    }
  },
  methods: {
    show(info) {
      this.info = info
      this.showDialog = true
    }
  },
  components: {
    VideoContainer,
    FileContainer
  }
}
